import { MAXIMUM_SCREEN_WIDTH_FOR_TWO_MONTH_CALENDAR } from "../constants";
export var getNumberOfMonths = function getNumberOfMonths(windowInnerWidth) {
  return windowInnerWidth < MAXIMUM_SCREEN_WIDTH_FOR_TWO_MONTH_CALENDAR ? 1 : undefined;
};